"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var compiler_1 = require("./compiler");
var jsx_1 = require("../jsx/jsx");
var locale_1 = require("./locale");
var compile = compiler_1.createCompiler({
    inject: null,
    partOffset: -1,
    before: function () { return ''; },
    after: function () { return '""'; },
    text: function (text) { return text + "+"; },
    value: function (part) { return part + "+"; },
});
function i18n(phrase, parts, ctx) {
    if (ctx === void 0) { ctx = 'default'; }
    var translatePhrase = locale_1.getTranslate(phrase, locale_1.getLang(), ctx);
    var compiledPhrase = compile(translatePhrase);
    return compiledPhrase(parts);
}
i18n['jsx'] = jsx_1.jsxFactory(react_1.createElement);
exports.default = i18n;
